import React from 'react'
import {NavLink, Link} from 'react-router-dom';
import Navbarmenu from './Navbarmenu';
import './LateralsContent.css';
import Container from '@material-ui/core/Container';

 function LateralsContent() {
    return (
        <>
            <div className="main-container" id="lateralscontent-box">
                <title>Security Learning - Laterals</title>
                <img src={process.env.PUBLIC_URL +"/images/entry-level-banner.png"} className="banner-img"/>
                <Navbarmenu/>
            </div>
            <Container className='laterals-container' maxWidth="xl">
                {/* section-1 */}
                {/* <p>Here is the Security learning guidance for entry and lateral resources to equip with the knowledge of some of the key security aspects as applicable to the different phases of SDLC. For security specialists playing security roles, there is a focus on deeper aspects of security learning.</p> */}
                <div className="laterals-wrap">
                    <h3>Laterals:</h3>
                    <p>Being Security very critical in today’s day to day role, it is important for us to equip the lateral hires with the knowledge to efficiently use the tools and become better defenders of the organization. These training may assist them to better manage their work in a more secure way as they will have security in mind.</p>
                </div>
                {/* section-2 */}
                <div className="learning-format-wrap">
                    <div className="learning-format-row">
                        <div className="learning-format-box">
                            <a href="#"><img src={process.env.PUBLIC_URL +"/images/DLF-L1.png"} alt="security-learning" className="learn-format-img" /></a>
                            <h2>DFA L1</h2>
                            <p>Career Level based mandatory online trainings of 22-26 hrs. covering fundamental delivery skills.</p>
                        </div>
                    </div>
                    <div className="learning-format-row">
                        <div className="learning-format-box">
                            <a href="#"><img src={process.env.PUBLIC_URL +"/images/DLF-L2.png"} alt="security-learning" className="learn-format-img" /></a>
                            <h2>DFA L2</h2>
                            <p>Trainings for different Role Families like Application Development, Software Engineering etc. <br/>
                             <b>(To be launched soon) </b></p>
                             

                        </div>
                    </div>
                    <div className="learning-format-row">
                        <div className="learning-format-box">
                            <a href="#"><img src={process.env.PUBLIC_URL +"/images/IS-Advocate.png"} alt="security-learning" className="learn-format-img" /></a>
                            <h2>IS Advocate</h2> 
                            <p>The Information Security Advocate program increases security awareness and secure behavior adoption through the completion of interactive learning activities. <span>
                                <a href="https://in.accenture.com/protectingaccenture/dashboard/" target="_blank">Explore Now</a></span> </p>
                        </div>
                    </div>
                </div>
                <div className="learning-format-wrap">
                    <div className="learning-format-row">
                        <div className="learning-format-box">
                            <a href="#"><img src={process.env.PUBLIC_URL +"/images/Security-Specialization-Role-Based.png"} alt="security-learning" className="learn-format-img" /></a>
                            <h2>Security Specialization <br /> – Role Based</h2>
                            <p>Security Learning Paths specific to 12 Role Families. <span>
                                <NavLink to="/role-based" target="_blank" >Explore Now</NavLink></span> </p>
                        </div>
                    </div>
                    <div className="learning-format-row">
                        <div className="learning-format-box">
                            <a href="#"><img src={process.env.PUBLIC_URL +"/images/Need-Based-Security-Learnings.png"} alt="security-learning" className="learn-format-img" /></a>
                            <h2>Need Based <br /> Security Learnings</h2>
                            <p>Security Learning Practices defines a learning plan based on the project's requirements.</p>
                        </div>
                    </div>

                    <div className="learning-format-row">
                        <div className="learning-format-box">
                            <a href="#"><img src={process.env.PUBLIC_URL +"/images/Client-Protection.png"} alt="security-learning" className="learn-format-img" /></a>
                            <h2>Client Data Protection (CDP)</h2>
                            <p>Accenture’s Client Data Protection program (CDP) is a fundamental component 
of our information security defenses.The CDP program helps protect the 
reputation and financial performance of both Accenture and our clients.
<span><a href="https://in.accenture.com/protectingaccenture/dashboard/" target="_blank">Explore Now</a> </span>
</p>
                        </div>
                    </div>
                </div>
            </Container>
        </>
    )
}
export default LateralsContent;